import { useEffect, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { api, backgroundRequestConfig } from '../../api';
import { saveAuthSession, toAuthSession } from '../../utils/authStorage';
import { cancelReauth, completeReauth, setReauthAvailable, useReauthStore } from '../../utils/reauthStore';

export function ReauthPopup() {
	const open = useReauthStore((state) => state.open);
	const [error, setError] = useState('');
	const [signingIn, setSigningIn] = useState(false);

	useEffect(() => {
		setReauthAvailable(true);
		return () => {
			setReauthAvailable(false);
			cancelReauth();
		};
	}, []);

	useEffect(() => {
		if (open) setError('');
	}, [open]);

	const handleSuccess = async (credentialResponse) => {
		try {
			setError('');
			setSigningIn(true);
			if (!credentialResponse?.credential) throw new Error('Google credential is missing.');
			const { data } = await api.googleLogin(credentialResponse.credential, backgroundRequestConfig);
			if (data.returnCode !== '0') throw new Error(data.message);
			saveAuthSession(toAuthSession(data));
			completeReauth();
		} catch (err) {
			setError(err.message || 'Google login failed.');
		} finally {
			setSigningIn(false);
		}
	};

	const handleClose = (event, reason) => {
		if (reason === 'backdropClick' || signingIn) return;
		cancelReauth();
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle>Session expired</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>
					Sign in with your FunkyGames Google account to continue. Your current page stays as it is and the request
					is sent again after you sign in.
				</DialogContentText>
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<GoogleLogin onSuccess={handleSuccess} onError={() => setError('Google login failed.')} />
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => handleClose()} disabled={signingIn}>
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
}
